import axios from '@/plugins/axios';
import storeutils from '@/stores/utils';
import utils from '@/utils';
import orderitems from "./submodules/orderitems";
import receiptitems from "./submodules/receiptitems";
import shipmentitems from "./submodules/shipmentitems";
import catalogentries from "./submodules/catalogentries";
import store from '@/stores/store';

const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = storeutils;

const providerStockproductsInflightByCatalogProductId = new Map();

const state = {
    product: null,
    product_loading: false,
    product_loading_errors: null,
    product_archiving: false,
    product_unarchiving: false,

    provider_id: null,

    producttypes: [],
    producttypes_loading: false,
    producttypes_loading_errors: null,

    productpictures: [],
    productpictures_count: 0,
    productpictures_loading: false,
    productpictures_loading_errors: null,

    productpicture_saving: false,
    productpicture_saving_errors: null,

    productproviders: [],
    productproviders_count: 0,
    productproviders_filters: { limit: 20 },
    productproviders_loading: false,
    productproviders_loading_errors: null,
    productproviders_saving: false,
    productproviders_saving_errors: null,

    product_stats: {},
    product_stats_loaded: false,
    product_stats_loading: false,
    product_stats_loading_errors: null,

    section: null,
    mode: null,
    creating_sale_product: false,

    /** Stock products for the linked sale product (child), in the current entity's warehouses */
    stockproducts: [],
    stockproducts_count: 0,
    /** From ``GET /api/stockproducts/stats/`` (same filters as listing). */
    stockproducts_stats: null,
    stockproducts_stats_loading: false,
    stockproducts_loading: false,
    stockproducts_fetching_errors: null,
    /** Serialized list API params for the last successful stockproducts fetch. */
    stockproducts_cached_request: null,
    /** Paginated / filtered rows for the provider product stock tab table only. */
    stockproducts_table: [],
    stockproducts_table_count: 0,
    stockproducts_table_loading: false,
    stockproducts_table_fetching_errors: null,
    stockproducts_table_cached_request: null,
    stockproducts_table_loaded: false,

    evolution: null,
    evolutionPeriod: null,
    evolutionLoading: false,
    evolutionLoadingErrors: {},

    stock_weekly_stats: null,
    stock_weekly_stats_loading: false,

    movements: [],
    movements_filters: {
        offset: 0,
        limit: 20,
        ordering: '-movement_date',
    },
    movements_count: 0,
    movements_loading: false,
    movements_loaded: false,
    movements_loading_errors: null,
};


const mutations = {

    updateProduct(state, product) {
        if (!product) {
            state.product = null;
            state.creating_sale_product = false;
            state.product_stats = {};
            state.product_stats_loaded = false;
            state.productpictures = [];
            state.productpictures_count = 0;
            state.stockproducts = [];
            state.stockproducts_count = 0;
            state.stockproducts_stats = null;
            state.stockproducts_stats_loading = false;
            state.stockproducts_fetching_errors = null;
            state.stockproducts_cached_request = null;
            state.stockproducts_table = [];
            state.stockproducts_table_count = 0;
            state.stockproducts_table_loading = false;
            state.stockproducts_table_fetching_errors = null;
            state.stockproducts_table_cached_request = null;
            state.stockproducts_table_loaded = false;
            state.movements = [];
            state.movements_count = 0;
            state.movements_loaded = false;
            state.stock_weekly_stats = null;
            return;
        }

        if (product && state.product && product.id && state.product.id) {
            if (product.id !== state.product.id) {
                state.stockproducts = [];
                state.stockproducts_count = 0;
                state.stockproducts_stats = null;
                state.stockproducts_stats_loading = false;
                state.stockproducts_fetching_errors = null;
                state.stockproducts_cached_request = null;
                state.stockproducts_table = [];
                state.stockproducts_table_count = 0;
                state.stockproducts_table_loading = false;
                state.stockproducts_table_fetching_errors = null;
                state.stockproducts_table_cached_request = null;
                state.stockproducts_table_loaded = false;
                state.movements = [];
                state.movements_count = 0;
                state.movements_loaded = false;
                state.stock_weekly_stats = null;
                state.product_stats = {};
                state.product_stats_loaded = false;
                state.movements_filters = {
                    ...state.movements_filters,
                    offset: 0,
                    product: product.id,
                };
            }
            state.product = product;
            return;
        }
        state.product = product;
        state.creating_sale_product = false;

        state.productpictures = [];
        state.productpictures_count = 0;
        state.stockproducts = [];
        state.stockproducts_count = 0;
        state.stockproducts_stats = null;
        state.stockproducts_stats_loading = false;
        state.stockproducts_fetching_errors = null;
        state.stockproducts_cached_request = null;
        state.stockproducts_table = [];
        state.stockproducts_table_count = 0;
        state.stockproducts_table_loading = false;
        state.stockproducts_table_fetching_errors = null;
        state.stockproducts_table_cached_request = null;
        state.stockproducts_table_loaded = false;
        state.movements = [];
        state.movements_count = 0;
        state.movements_loaded = false;
        state.stock_weekly_stats = null;
        state.movements_filters = {
            ordering: '-movement_date',
            limit: 20,
            ...loadFiltersFromStorage(getStorageKey('providerproduct', 'movements')),
            offset: 0,
            product: product?.id,
        };
    },

    updateStockProducts(state, stockproducts) {
        state.stockproducts = stockproducts || [];
        state.stockproducts_fetching_errors = null;
    },
    updateStockProductsCount(state, count) {
        state.stockproducts_count = count ?? 0;
    },
    updateStockProductsTable(state, stockproducts) {
        state.stockproducts_table = stockproducts || [];
        state.stockproducts_table_fetching_errors = null;
    },
    updateStockProductsTableCount(state, count) {
        state.stockproducts_table_count = count ?? 0;
    },
    updateStockProductsTableLoading(state, loading) {
        state.stockproducts_table_loading = loading;
    },
    updateStockProductsTableFetchingErrors(state, errors) {
        state.stockproducts_table_fetching_errors = errors;
        if (errors) {
            state.stockproducts_table_cached_request = null;
        }
    },
    updateStockProductsTableCachedRequest(state, signature) {
        state.stockproducts_table_cached_request = signature ?? null;
    },
    updateStockProductsTableLoaded(state, loaded) {
        state.stockproducts_table_loaded = loaded;
    },
    patchStockProductLocation(state, { id, location }) {
        const patchRow = (row) =>
            row.id === id ? { ...row, location } : row;
        state.stockproducts = (state.stockproducts || []).map(patchRow);
        state.stockproducts_table = (state.stockproducts_table || []).map(
            patchRow,
        );
    },
    updateStockProductsStats(state, stats) {
        state.stockproducts_stats = stats || null;
    },
    updateStockProductsStatsLoading(state, loading) {
        state.stockproducts_stats_loading = loading;
    },
    updateStockProductsFetchingErrors(state, errors) {
        state.stockproducts_fetching_errors = errors;
        if (errors) {
            state.stockproducts_cached_request = null;
        }
    },
    updateStockProductsCachedRequest(state, signature) {
        state.stockproducts_cached_request = signature ?? null;
    },
    invalidateStockProductsCache(state) {
        state.stockproducts_cached_request = null;
        state.stockproducts_table_cached_request = null;
    },
    updateStockProductsLoading(state, loading) {
        state.stockproducts_loading = loading;
    },

    updateProviderId(state, provider_id) {
        state.provider_id = provider_id;
    },

    updateSection(state, section) {
        state.section = section;
    },

    updateMode(state, mode) {
        state.mode = mode;
    },

    updateProductLoading(state, loading) {
        state.product_loading = loading;
    },
    updateProductLoadingErrors(state, errors) {
        state.product_loading_errors = errors;
    },

    updateProductArchiving(state, archiving) {
        state.product_archiving = archiving;
    },
    updateProductUnarchiving(state, unarchiving) {
        state.product_unarchiving = unarchiving;
    },

    updateProductPictures(state, productpictures) {
        state.productpictures = productpictures;
    },
    updateProductPicturesCount(state, count) {
        state.productpictures_count = count;
    },
    updateProductPicturesLoading(state, loading) {
        state.productpictures_loading = loading;
    },
    updateProductPicturesLoadingErrors(state, errors) {
        state.productpictures_loading_errors = errors;
    },

    updateProductPictureSavingErrors(state, errors) {
        state.productpicture_saving_errors = errors;
    },
    updateProductPictureSaving(state, saving) {
        state.productpicture_saving = saving;
    },


    updateProductStats(state, stats) {
        state.product_stats = stats;
        state.product_stats_loaded = true;
    },
    updateProductStatsLoaded(state, loaded) {
        state.product_stats_loaded = loaded;
    },
    updateProductStatsLoading(state, loading) {
        state.product_stats_loading = loading;
    },
    updateProductStatsLoadingErrors(state, errors) {
        state.product_stats_loading_errors = errors;
    },

    updateCreatingSaleProduct(state, creating) {
        state.creating_sale_product = creating;
    },

    updateMovements(state, data) {
        state.movements = data.results;
        state.movements_count = data.count;
        state.movements_loaded = true;
    },
    updateMovementsLoading(state, loading) {
        state.movements_loading = loading;
    },
    updateMovementsLoadingErrors(state, errors) {
        state.movements_loading_errors = errors;
    },
    updateMovementsFilters(state, filters) {
        state.movements_filters = filters;
        saveFiltersToStorage(
            getStorageKey('providerproduct', 'movements'),
            state.movements_filters,
            ['limit', 'ordering'],
        );
    },
    updateEvolution(state, evolution) {
        state.evolution = {
            labels: evolution.labels.map((label) => new Date(label)),
            datasets: evolution.datasets,
        };
        state.evolutionLoading = false;
        state.evolutionLoadingErrors = {};
    },
    updateEvolutionPeriod(state, evolutionPeriod) {
        state.evolution = null;
        state.evolutionPeriod = evolutionPeriod;
    },
    updateEvolutionLoading(state, evolutionLoading) {
        state.evolutionLoading = evolutionLoading;
    },
    updateEvolutionLoadingErrors(state, evolutionLoadingErrors) {
        state.evolutionLoading = false;
        state.evolutionLoadingErrors = evolutionLoadingErrors;
    },

    updateStockWeeklyStats(state, stats) {
        state.stock_weekly_stats = stats;
    },
    updateStockWeeklyStatsLoading(state, loading) {
        state.stock_weekly_stats_loading = loading;
    },

};

const actions = {

    async fetchProductStats({ commit, dispatch, state }, params) {
        commit('updateProductStatsLoading', true);
        try {
            const response = await axios.get(`/api/providerproducts/${state.product.id}/stats/`);
            commit('updateProductStats', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            commit('updateProductLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductStatsLoading', false);
        }
    },

    async fetchMovements({ commit, state }) {
        if (!state.product) {
            return;
        }
        commit('updateMovementsLoading', true);
        commit('updateMovementsLoadingErrors', null);
        try {
            const response = await axios.get('/api/movements/', {
                params: state.movements_filters,
            });
            commit('updateMovements', response.data);
            return response;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            commit('updateMovementsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateMovementsLoading', false);
        }
    },

    async fetchStockWeeklyStats({ commit, state }) {
        if (!state.product?.id) {
            return;
        }
        commit('updateStockWeeklyStatsLoading', true);
        try {
            const params = { ...state.movements_filters };
            delete params.offset;
            delete params.limit;
            delete params.ordering;
            params.movement_date_max = new Date().toISOString().slice(0, 10);
            const response = await axios.get('/api/movements/inventory/weekly-stats/', {
                params,
            });
            commit('updateStockWeeklyStats', response.data);
            return response.data;
        } catch (xhr_error) {
            commit('updateStockWeeklyStats', []);
            storeutils.handleError(xhr_error);
        } finally {
            commit('updateStockWeeklyStatsLoading', false);
        }
    },

    async fetchProduct({ commit, dispatch, state }, params) {
        commit('updateProductLoading', true);
        let url = null;
        if (params && params.product_id) {
            url = `/api/providerproducts/${params.product_id}/`;
        } else if (state.product) {
            url = `/api/providerproducts/${state.product.id}/`;
        } else {
            throw "no product to fetch";
        }
        try {
            const response = await axios.get(url);
            commit('updateProduct', response.data);
            try {
                await dispatch('fetchChildStockProducts', { force: true });
            } catch (xhr_error) {
                storeutils.handleError(xhr_error);
            }
            return response.data;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            commit('updateProductLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductLoading', false);
        }
    },

    async refreshStockTabTableIfLoaded({ state, dispatch }) {
        if (!state.product?.id || !state.stockproducts_table_loaded) {
            return;
        }
        const filters = storeutils.filtersFromStockTableCache(
            state.stockproducts_table_cached_request,
        );
        await dispatch('fetchChildStockProducts', {
            force: true,
            target: 'table',
            filters,
        });
        return dispatch('fetchChildStockProductsStats', { filters });
    },

    async fetchChildStockProducts(
        { commit, state },
        { force = false, filters = null, target = 'summary' } = {},
    ) {
        const providerProduct = state.product;
        if (!providerProduct?.id) {
            if (target === 'table') {
                commit('updateStockProductsTable', []);
                commit('updateStockProductsTableCount', 0);
                commit('updateStockProductsTableCachedRequest', null);
                commit('updateStockProductsTableLoading', false);
                commit('updateStockProductsTableLoaded', false);
            } else {
                commit('updateStockProducts', []);
                commit('updateStockProductsCount', 0);
                commit('updateStockProductsCachedRequest', null);
                commit('updateStockProductsLoading', false);
            }
            providerStockproductsInflightByCatalogProductId.clear();
            return;
        }
        /** Provider catalog product id (same as route `product_id`). */
        const catalogProductId = providerProduct.id;
        const listFilters = filters || {};
        const apiParams = {
            provider_catalog_product: catalogProductId,
            limit: listFilters.limit ?? 2000,
            offset: listFilters.offset ?? 0,
        };
        const search = (listFilters.search || '').trim();
        if (search) {
            apiParams.search = search;
        }
        if (listFilters.stock != null && listFilters.stock !== '') {
            apiParams.stock = listFilters.stock;
        }
        if (listFilters.stock_owner) {
            apiParams.stock_owner = listFilters.stock_owner;
        }
        const cacheSignature = JSON.stringify(apiParams);
        const key = `${target}:${cacheSignature}`;
        const isTable = target === 'table';
        const cachedRequest = isTable
            ? state.stockproducts_table_cached_request
            : state.stockproducts_cached_request;
        const fetchingErrors = isTable
            ? state.stockproducts_table_fetching_errors
            : state.stockproducts_fetching_errors;

        if (
            !force &&
            cachedRequest === cacheSignature &&
            !fetchingErrors
        ) {
            return isTable ? state.stockproducts_table : state.stockproducts;
        }

        if (force) {
            providerStockproductsInflightByCatalogProductId.delete(key);
        }

        const existing = providerStockproductsInflightByCatalogProductId.get(
            key,
        );
        if (!force && existing) {
            return existing;
        }

        const promise = (async () => {
            if (isTable) {
                commit('updateStockProductsTableLoading', true);
                commit('updateStockProductsTableFetchingErrors', null);
            } else {
                commit('updateStockProductsLoading', true);
                commit('updateStockProductsFetchingErrors', null);
            }
            try {
                const response = await axios.get('/api/stockproducts/', {
                    params: apiParams,
                });
                const results = response.data.results || [];
                const count = response.data.count ?? 0;
                if (isTable) {
                    commit('updateStockProductsTable', results);
                    commit('updateStockProductsTableCount', count);
                    commit(
                        'updateStockProductsTableCachedRequest',
                        cacheSignature,
                    );
                    commit('updateStockProductsTableLoaded', true);
                } else {
                    commit('updateStockProducts', results);
                    commit('updateStockProductsCount', count);
                    commit('updateStockProductsCachedRequest', cacheSignature);
                }
                return results;
            } catch (xhr_error) {
                const error = storeutils.handleError(xhr_error);
                if (isTable) {
                    commit(
                        'updateStockProductsTableFetchingErrors',
                        error.details,
                    );
                    commit('updateStockProductsTable', []);
                    commit('updateStockProductsTableCount', 0);
                    commit('updateStockProductsTableCachedRequest', null);
                    commit('updateStockProductsTableLoaded', true);
                } else {
                    commit('updateStockProductsFetchingErrors', error.details);
                    commit('updateStockProducts', []);
                    commit('updateStockProductsCount', 0);
                    commit('updateStockProductsCachedRequest', null);
                }
                throw error;
            } finally {
                if (isTable) {
                    commit('updateStockProductsTableLoading', false);
                } else {
                    commit('updateStockProductsLoading', false);
                }
            }
        })()
            .finally(() => {
                if (
                    providerStockproductsInflightByCatalogProductId.get(key) ===
                    promise
                ) {
                    providerStockproductsInflightByCatalogProductId.delete(
                        key,
                    );
                }
            });

        providerStockproductsInflightByCatalogProductId.set(key, promise);
        return promise;
    },

    async fetchChildStockProductsStats({ commit, state }, { filters = null } = {}) {
        if (!state.product?.id) {
            commit('updateStockProductsStats', null);
            return;
        }
        const listFilters = filters || {};
        const apiParams = {
            provider_catalog_product: state.product.id,
        };
        const search = (listFilters.search || '').trim();
        if (search) {
            apiParams.search = search;
        }
        if (listFilters.stock != null && listFilters.stock !== '') {
            apiParams.stock = listFilters.stock;
        }
        if (listFilters.stock_owner) {
            apiParams.stock_owner = listFilters.stock_owner;
        }
        commit('updateStockProductsStatsLoading', true);
        try {
            const response = await axios.get('/api/stockproducts/stats/', {
                params: apiParams,
            });
            commit('updateStockProductsStats', response.data);
            return response.data;
        } catch (xhr_error) {
            commit('updateStockProductsStats', null);
            storeutils.handleError(xhr_error);
        } finally {
            commit('updateStockProductsStatsLoading', false);
        }
    },

    async archiveProduct({ commit, dispatch, state }, params) {
        commit('updateProductArchiving', true);

        const url = `/api/providerproducts/${state.product.id}/archive/`;
        try {
            const response = await axios.post(url);
            dispatch('session/fetchStats', null, { root: true });
            dispatch("fetchProduct");
            return response;
        } catch (xhr_error) {
            throw storeutils.handleError(xhr_error);
        } finally {
            commit('updateProductArchiving', false);
        }
    },

    async unarchiveProduct({ commit, dispatch, state }, params) {
        try {
            await axios.post(`/api/providerproducts/${state.product.id}/unarchive/`);
        } finally {
            dispatch("fetchProduct");
        }
    },


    async fetchProductPictures({ commit, dispatch, state }, params) {
        commit('updateProductPicturesLoading', true);
        commit('updateProductPicturesLoadingErrors', null);

        try {
            const response = await axios.get('/api/productpictures/', { params: { limit: 100, product: state.product.id } });
            commit('updateProductPictures', response.data.results);
            commit('updateProductPicturesCount', response.data.count);
            return response;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            commit('updateProductPicturesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductPicturesLoading', false);
        }
    },

    async saveProductPicture({ commit, dispatch, state }, params) {
        if (!params || !params.instance) {
            return;
        }

        let headers = {};
        let data = params.instance;
        let url = '/api/productpictures/';
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/productpictures/${params.instance.id}/`;
            method = params.patch ? axios.patch : axios.put;
        } else {
            headers = { 'Content-Type': 'multipart/form-data' };
            data = new FormData();
            for (let key in params.instance) {
                if (params.instance[key]) {
                    data.append(key, params.instance[key]);
                }
            }
        }

        commit('updateProductPictureSavingErrors', null);
        commit('updateProductPictureSaving', true);

        try {
            const response = await method(url, data, { headers });
            return { productpicture: response.data };
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            commit('updateProductPictureSavingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductPictureSaving', false);
        }
    },


    async deleteProductPicture({ commit, dispatch, state }, params) {
        const url = `/api/productpictures/${params.instance.id}/`;

        try {
            const response = await axios.delete(url);
            return response;
        } catch (xhr_error) {
            const error = storeutils.handleError(xhr_error);
            throw error;
        }
    },


    async init({ commit, dispatch, state }, params) {
        await commit('updateSection', params.section || null);
        await commit('updateMode', params.mode || null);
        await dispatch('providerorderitems/init', {
            filters: { product: params.product.id, }, type: 'providerorder',
        });
        await dispatch('customerorderitems/init', {
            filters: { product: params.product.id, order_suborder: true, order_providerorder: true}, type: 'customerorder', 
        });
        await dispatch('receiptitems/init', {
            filters: { product: params.product.id },
        });
        await dispatch('shipmentitems/init', {
            filters: { product: params.product.id },
        });

        if (params.product.owner == store.getters['session/current_entity_id']) {
            await commit('updateProviderId', params.product.provider);
        } else {
            const provider_id = await utils.lookup("provider", { entity: params.product.owner });
            commit('updateProviderId', provider_id);
        }
        await commit('updateProduct', params.product);
        try {
            await dispatch('fetchChildStockProducts');
        } catch (xhr_error) {
            storeutils.handleError(xhr_error);
        }
        // Stats are fetched by the view before init, so we don't need to fetch them here
        // dispatch('fetchProductStats');
    },

    async createSaleProduct({ commit, dispatch, state }, params) {
        commit("updateCreatingSaleProduct", params.catalogentries);
        try {
            const response = await axios.post(`/api/importproducts/`, {
                products: [state.product.id],
            });
            return response;
        } catch (xhr_error) {
            throw storeutils.handleError(xhr_error);
        } finally {
            dispatch("fetchProduct");
            commit("updateCreatingSaleProduct", params.products);
        }
    }

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        providerorderitems: orderitems({
            storageKey: getStorageKey('providerproduct', 'providerorderitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        customerorderitems: orderitems({
            storageKey: getStorageKey('providerproduct', 'customerorderitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        receiptitems: receiptitems({
            storageKey: getStorageKey('providerproduct', 'receiptitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        shipmentitems: shipmentitems({
            storageKey: getStorageKey('providerproduct', 'shipmentitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        catalogentries: catalogentries({
            storageKey: getStorageKey('providerproduct', 'catalogentries'),
            fieldsToSave: ['limit', 'ordering']
        }),
    },
};

